import type { CSSProperties } from 'react';

import { SUPPORT_EMAIL } from '@/config/constants';
import type { Sx } from '@/shared/types/uiTypes';

export const SupportContact = ({ sx: _sx, style }: { sx?: Sx; style?: CSSProperties }) => (
  <p style={style}>
    Any issues? Drop us a line at{' '}
    <a
      className='whitespace-nowrap text-gx-text underline'
      href={`mailto:${SUPPORT_EMAIL}`}
      target='_top'
    >
      {SUPPORT_EMAIL}
    </a>
  </p>
);
